import type { NavigationStateRecord } from "../types";

/**
 * Get the total number of substeps left to complete in a step (navigation state record).
 * @deprecated
 */
export function getTotalSubStepsLeftFromStep(record: NavigationStateRecord) {
  if (!record.steps) {
    return undefined;
  }

  const totalSubSteps = record.steps.length;
  const completedSubSteps = record.steps.filter(
    (subStep) => subStep.completed || !!subStep.icon,
  ).length;

  if (totalSubSteps === 0) {
    return undefined;
  }

  return totalSubSteps - completedSubSteps;
}
